import styled from "styled-components";

import { getOpacityColor, grayScale } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import { ellipsis } from "@enkor/design/mixins";

export const REVIEW_IMAGE_SIZE = 42;
const GAP_BETWEEN = 16;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 296px;
  height: 190px;
  margin-left: ${GAP_BETWEEN}px;
  padding: 12px;
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale[300], 0.7)};

  cursor: pointer;
`;

export const ReviewerWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  &:first-child {
    grid-column: 1 / 3;
  }
`;

export const EventAndReviewerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ReviewerNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ReviewerName = styled(Typo.Text)`
  color: ${grayScale[800]};
`;

export const ReviewedTime = styled(Typo.Text)`
  margin-left: 4px;

  color: ${grayScale[500]};
`;

export const ReviewContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EventTitle = styled(Typo.Text)`
  color: ${grayScale[800]};

  ${ellipsis(1)}
`;

export const ReviewContent = styled(Typo.Text)<{ $showMore: boolean }>`
  ${({ $showMore }) => ellipsis($showMore ? 1 : 3)}
`;

export const RatingWrapper = styled.div`
  display: flex;
  gap: 8px;

  width: 100%;
  height: 24px;
  margin-top: auto;

  svg {
    margin: auto 0;
    margin-left: auto;
  }
`;

export const ImageList = styled.div`
  display: flex;
  gap: 8px;
`;

export const ImageWrapper = styled.div`
  overflow: hidden;

  width: ${REVIEW_IMAGE_SIZE}px;
  height: ${REVIEW_IMAGE_SIZE}px;
  border-radius: 8px;
`;
